import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/Button";
import { useMobileNavContext } from "context/mobileNavContext";
import { Link, useIntl } from "gatsby-plugin-intl";
import logoImgFr from "images/logo_fr.png";
import logoImgAr from "images/logo_ar.png";
// import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";
import "./header.scss";
import LanguageSwitch from "./LanguageSwitch";
import Navigation from "./Navigation";
import Search from "./Search";

const Header = () => {
  const [searchOpen, setSearch] = useState(false);
  const mobileNavContext = useMobileNavContext();
  const { locale } = useIntl();

  return (
    <div
      className="header-navigation shadow-light bg-white fixed top-0 left-0 right-0 z-40"
      dir="ltr"
    >
      <div className="bg-gradient-primary-2 text-base lg:text-md py-2 text-white text-center min-h-10 flex flex-col justify-center">
        <div className="container" dir={locale === "ar" ? "rtl" : "ltr"}>
          {/* <FormattedMessage id="navigation.workSchedule" /> */}
        </div>
      </div>
      <div className="h-20 flex flex-col justify-center">
        <div className="container relative flex items-center md:w-full h-full py-2">
          <div className="w-40 xs:w-40 xl:w-40 ">
            <Link to="/">
              <img
                className="max-w-full w-full"
                src={locale === "ar" ? logoImgAr : logoImgFr}
                alt="chaabicash.ma"
              />
            </Link>
          </div>

          <div className="ml-auto hidden lg:block h-full">
            {!searchOpen ? (
              <Navigation />
            ) : (
              <Search onSearchClose={() => setSearch(false)} />
            )}
          </div>

          {/* <div className="rtl:ml-6 hidden lg:block">
          {!searchOpen && (
            <SearchButton onClick={() => setSearch(!searchOpen)} />
            )}
          </div> */}

          <div className="ml-auto lg:ltr:ml-6">
            <LanguageSwitch />
          </div>

          <div className="block lg:hidden ml-4">
            <div className="my-4 mx-auto">
              <Button
                onClick={mobileNavContext.toggle}
                className="p-3 focus:outline-none"
              >
                {mobileNavContext.open ? (
                  <svg
                    height="14pt"
                    viewBox="0 0 329.26933 329"
                    width="14pt"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0" />
                  </svg>
                ) : (
                  <svg
                    height="14pt"
                    viewBox="0 -53 384 384"
                    width="14pt"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" />
                    <path d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" />
                    <path d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" />
                  </svg>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SearchButton = ({ onClick }) => {
  return (
    <Button onClick={onClick} className="rounded-full p-3">
      <FontAwesomeIcon fixedWidth className="text-gray-800" icon={faSearch} />
    </Button>
  );
};

SearchButton.propTypes = {
  onClick: PropTypes.func,
};

export default Header;
